import React, {useEffect} from "react";
import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import { FancyboxContext } from "./FancyboxContext";
import { createRoot } from 'react-dom/client';
import "@fancyapps/ui/dist/fancybox.css";
import "./fancybox.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import store from '../../store/store';
import { Provider } from 'react-redux';

import _ from "lodash";

const fancybox = (content, options) => {

    if(typeof options == 'undefined')
    {
        options = {}
    }

    if(typeof options.on == 'undefined')
    {
        options.on = {}
    }

    var FancyboxOptions = _.extend({},options, {
        root : content
        ,on : {
            done : (fancybox, slide) => {               
                fancybox.ReactRoot = createRoot(slide.$content.firstChild);

                fancybox.ReactRoot.render(
                    <BrowserRouter basename='/'>
                        <FancyboxContext fancybox={fancybox}>
                            <Provider store={store}>
                                {fancybox.options.root}
                            </Provider>
                        </FancyboxContext>
                    </BrowserRouter>
                );
            }
            ,closing : function(fancybox){
                if(fancybox.ReactRoot)
                {
                    fancybox.ReactRoot.unmount();
                }
            }
        }
    });

    return  new NativeFancybox([
        {
            src : '<div></div>'
            ,type : 'html'
        }
    ], FancyboxOptions );
}

const popinfo = (type, title, content, options, instance) => {

    var content = '<div class="popinfo '+type+'"><span class="icon-wrapper"></span><span><span class="poptype">'+title+'</span><span class="message">'+content+'</span></span></div>';

    var isLoader = ['loader', 'loading', 'preloader'].indexOf(type) >= 0;

    var options = _.extend({}, {
        mainClass: 'popinfo-container'
        ,autoHide : isLoader ? false : true
        ,dragToClose : false
        ,click : isLoader ? () => {} : 'close'
        ,closeButton : isLoader ? false : 'inside'
    }, options || {});


    if(typeof instance != 'undefined')
    {
        var slide = instance.getSlide();
        instance.clearContent(slide);
        instance.setContent(slide, content, options);

        if(options.autoHide)
        {
            _.delay(() => {
                instance.close()
            }, 5000);
        }

        return instance;
    }

    var NFB = new NativeFancybox([
        {
          src: content
          ,type: "html"
        }
    ], options );

    if(options.autoHide)
    {
        _.delay(() => {
            NFB.close()
        }, 2000);
    }

    return NFB;
};

export {popinfo};

export default fancybox;

